import { useColorModeValue } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { FirebaseContext } from '@/session/FirebaseContext';
import { useAuthModal } from '@/hooks';
import { SITE_NAV_ROUTES } from './siteNavRoutes';

export function useSiteNavNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const ctx = useContext(FirebaseContext);
  const { openLoginModal } = useAuthModal();
  const activeColor = useColorModeValue('gray.900', 'white');
  const inactiveColor = useColorModeValue('gray.600', 'gray.300');
  const hoverBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.100');
  const activeBg = useColorModeValue('blackAlpha.100', 'whiteAlpha.200');

  function isActive(path: string) {
    return location.pathname === path;
  }

  function onNavClick(path: string, onAfterNavigate?: () => void) {
    if (path === '/profile' && !ctx.user) {
      openLoginModal();
      onAfterNavigate?.();
      return;
    }
    navigate(path);
    onAfterNavigate?.();
  }

  return {
    routes: SITE_NAV_ROUTES,
    isActive,
    onNavClick,
    activeColor,
    inactiveColor,
    hoverBg,
    activeBg,
  };
}
